// action - state management
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT, AUTH_MENU } from './actions';

export const initialState = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    name: null,
    user_id: null,
};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { isLoggedIn, user, user_id, token, permissions, authMenu, refresh, name, display_column_preference, matched_profiles_column_preference, audit_column_preference, candidate_profiles_column_preference, scraping_modal, scraping_content, scrape_verification_required, scrape_portal, implementer_type } = action.payload;
            return {
                ...state,
                isLoggedIn: isLoggedIn ?? state.isLoggedIn,
                isInitialized: true,
                token: token ?? state.token,
                user: user ?? state.user,
                user_id: user_id ?? state.user_id,
                authMenu: authMenu ?? state.authMenu,
                name: name ?? state.name,
                display_column_preference: display_column_preference ?? state.display_column_preference,
                matched_profiles_column_preference: matched_profiles_column_preference ?? state.matched_profiles_column_preference,
                audit_column_preference: audit_column_preference ?? state.audit_column_preference,
                candidate_profiles_column_preference: candidate_profiles_column_preference ?? state.candidate_profiles_column_preference,
                permissions: permissions ?? state.permissions,
                refresh: refresh ?? state.refresh,
                loginTime: new Date(),
                scraping_modal: scraping_modal ?? state.scraping_modal,
                scraping_content: scraping_content ?? state.scraping_content,
                scrape_verification_required: scrape_verification_required ?? state.scrape_verification_required,
                scrape_portal: scrape_portal ?? state.scrape_portal,
                implementer_type: implementer_type ?? state.implementer_type
            };
        }
        case LOGIN: {
            const { user, user_id, name, role, id } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                user,
                user_id
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                token: '',
                user: null,
                authMenu: null,
                permissions:null,
                user_id: null
            };
        }
        case AUTH_MENU: {
            const { menuItem } = action.payload;
            return {
                ...state,
                menuItem 
            }
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
